export default "__VITE_PUBLIC_ASSET__ab36a150__"